export default __webpack_public_path__ + "static/media/sd-jyotirlingas.01d7a82e.png";